(function () {
  if (!location.pathname.includes('/pages/store-locator')) return;

  const params = new URLSearchParams(window.location.search);
  const countryParam = params.get('country');
  if (!countryParam) return;

  const target = decodeURIComponent(countryParam).trim().toLowerCase();

  function findCountrySelect(root) {
    const selects = [...root.querySelectorAll('select')];

    // Identify the country dropdown by the unique list of country options
    return selects.find(sel => {
      const texts = [...sel.options].map(o => (o.textContent || '').trim());
      return texts.includes('Japan') && texts.includes('Australia') && texts.includes('South Korea');
    });
  }

  function applyCountry() {
    const root =
      document.querySelector('#storeifyapps-storelocator-index') ||
      document.querySelector('#storeifyapps-storelocator-shortcode') ||
      document;

    const sel = findCountrySelect(root);
    if (!sel) return false;

    const match = [...sel.options].find(o =>
      ((o.textContent || '').trim().toLowerCase() === target) ||
      ((o.value || '').trim().toLowerCase() === target)
    );

    if (!match) return false;

    sel.value = match.value;

    // Trigger app listeners
    sel.dispatchEvent(new Event('input', { bubbles: true }));
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    if (window.jQuery) window.jQuery(sel).trigger('change');

    return true;
  }

  // Run with retries because Storeify renders async
  let tries = 0;
  const maxTries = 120; // 30 seconds
  const timer = setInterval(() => {
    tries++;

    if (applyCountry()) {
      clearInterval(timer);

      // Some apps re-render once after initial load; re-apply once
      setTimeout(applyCountry, 800);
      return;
    }

    if (tries >= maxTries) clearInterval(timer);
  }, 250);
})();